module.exports = {
	"pages": [
		{
			"clients": [
				{
					"logo": "./src/assets/images/logos/afissore.png",
					"alt": "Logo Afissore",
					"client": "AFISSORE",
					"description": {
						"pt-BR": "Ong de atendimento à pessoas com fissuras labiopalatinas",
						"en-US": "Claft palate NGO"
					}
				},
				{
					"logo": "./src/assets/images/logos/agere.png",
					"alt": "Logo Ágere Soluções",
					"client": "ÁGERE SOLUÇÕES",
					"description": {
						"pt-BR": "Contabilidade especializada no Terceiro Setor",
						"en-US": "Third sector accounting"
					}
				},
				{
					"logo": "./src/assets/images/logos/agile.png",
					"alt": "Logo Agile Soluções",
					"client": "ÁGILE",
					"description": {
						"pt-BR": "Empresa de soluções em peças industriais",
						"en-US": "Industrial pieces solutions"
					}
				},
				{
					"logo": "./src/assets/images/logos/aina-barcelona.png",
					"alt": "Logo AINA Barcelona",
					"client": "AINA BARCELONA",
					"description": {
						"pt-BR": "Empresa de comércio de joias - Espanha",
						"en-US": "Jewelry store in Spain"
					}
				},
				{
					"logo": "./src/assets/images/logos/alpha-vida.png",
					"alt": "Logo Alpha Vida",
					"client": "Alpha Vida",
					"description": {
						"pt-BR": "Centro terapêutico de encaminhamento à recuperação de dependentes químicos",
						"en-US": "Narcotics Anonymous nonprofit fellowship"
					}
				},
				{
					"logo": "./src/assets/images/logos/amas.png",
					"alt": "Logo AMAS",
					"client": "AMAS",
					"description": {
						"pt-BR": "Ong de atendimento à pessoas com TEA - Transtorno do Espectro do Autismo",
						"en-US": "NGO for attendance to Autism"
					}
				},
				{
					"logo": "./src/assets/images/logos/apae-cabreuva.png",
					"alt": "Logo Apae Cabreúva",
					"client": "APAE CABREÚVA",
					"description": {
						"pt-BR": "Ong de atendimento à pessoas com deficiência",
						"en-US": "NGO to attend people with disability"
					}
				},
				{
					"logo": "./src/assets/images/logos/bewe.png",
					"alt": "Logo Bewe",
					"client": "AGÊNCIA BëWE",
					"description": {
						"pt-BR": "Agência parceira na criação de interfaces e projetos",
						"en-US": "Partner agency on projects and interfaces creation."
					}
				},
				{
					"logo": "./src/assets/images/logos/bluecore.png",
					"alt": "Logo Bluecore",
					"client": "BLUECORE",
					"description": {
						"pt-BR": "Software House parceira",
						"en-US": "Partner Software House"
					}
				},
				{
					"logo": "./src/assets/images/logos/crm.png",
					"alt": "Logo CRM Ambiental",
					"client": "CRM",
					"description": {
						"pt-BR": "Empresa na área da Engenharia Ambiental",
						"en-US": "Environmental engineering company"
					}
				},
				{
					"logo": "./src/assets/images/logos/destaque-propaganda.png",
					"alt": "Logo Destaque Propaganda",
					"client": "DESTAQUE PROPAGANDA",
					"description": {
						"pt-BR": "Empresa parceira em projetos",
						"en-US": "Partner company on projects"
					}
				},
				{
					"logo": "./src/assets/images/logos/donna-florinda.png",
					"alt": "Logo Donna Florinda",
					"client": "Donna Florinda",
					"description": {
						"pt-BR": "Pizzaria Artezanal",
						"en-US": "Handmade Pizzeria"
					}
				}
			]
		},
		{
			"clients": [
				{
					"logo": "./src/assets/images/logos/dpb.png",
					"alt": "Logo DPB",
					"client": "DPB",
					"description": {
						"pt-BR": "Portal do intercambista brasileiro no exterior",
						"en-US": "Portal to Brazilian exchange abroad"
					}
				},
				{
					"logo": "./src/assets/images/logos/flir.png",
					"alt": "Logo FLIR",
					"client": "FLIR",
					"description": {
						"pt-BR": "Multinacional líder mundial no segmento infravermelho",
						"en-US": "World wide leader on infrared segment"
					}
				},
				{
					"logo": "./src/assets/images/logos/eprocad.png",
					"alt": "Logo Eprocad",
					"client": "FUNDAÇÃO EPROCAD",
					"description": {
						"pt-BR": "Ong de atendimento à crianças e jovens na área esportiva",
						"en-US": "NGO to attend children and teens on sports area"
					}
				},
				{
					"logo": "./src/assets/images/logos/gerbo.png",
					"alt": "Logo Gerbo",
					"client": "GERBO GESTÃO",
					"description": {
						"pt-BR": "Empresa de tecnologia e software de gestão",
						"en-US": "Company of technology and management software"
					}
				},
				{
					"logo": "./src/assets/images/logos/intacta.png",
					"alt": "Logo Intacta",
					"client": "INTACTA",
					"description": {
						"pt-BR": "Empresa na área de sistemas de embalagens",
						"en-US": "Company specializing in the packaging segment"
					}
				},
				{
					"logo": "./src/assets/images/logos/intercambio-de-sucesso.png",
					"alt": "Logo Intercâmbio de Sucesso",
					"client": "INTERCÂMBIO DE SUCESSO",
					"description": {
						"pt-BR": "Portal com histórias de intercambistas de sucesso",
						"en-US": "Success stories of exchange students"
					}
				},
				{
					"logo": "./src/assets/images/logos/ipanema-clube.png",
					"alt": "Logo Ipanema Clube",
					"client": "IPANEMA CLUBE",
					"description": {
						"pt-BR": "Um dos maiores e mais tradicionais clubes de Sorocaba",
						"en-US": "One of the biggest and traditional clubs from Sorocaba/SP - Brazil"
					}
				},
				{
					"logo": "./src/assets/images/logos/isabel-exel-boemer.png",
					"alt": "Logo Isabel Exel",
					"client": "ASSOCIAÇÃO ISABEL EXEL BOEMER",
					"description": {
						"pt-BR": "Ong de atendimento à terceira idade",
						"en-US": "NGO who cares for the elderly"
					}
				},
				{
					"logo": "./src/assets/images/logos/itc.png",
					"alt": "Logo Portal ITC",
					"client": "PORTAL ITC",
					"description": {
						"pt-BR": "Portal FLIR Infrared Training Center Brasil",
						"en-US": "FLIR Systems portal Infrared Training Center Brazil"
					}
				},
				{
					"logo": "./src/assets/images/logos/instituto-vai.png",
					"alt": "Logo Instituto Vai",
					"client": "Instituto VAI",
					"description": {
						"pt-BR": "Ong de assessoramento ao empreendedorismo e terceiro setor",
						"en-US": "NGO advisory entrepreneurship and third sector"
					}
				},
				{
					"logo": "./src/assets/images/logos/keller.png",
					"alt": "Logo Keller Watches",
					"client": "KELLER",
					"description": {
						"pt-BR": "Empresa de comércio de joalheria da Irlanda",
						"en-US": "Jewelry store from Ireland"
					}
				},
				{
					"logo": "./src/assets/images/logos/lua-nova.png",
					"alt": "Logo Lua Nova",
					"client": "ONG LUA NOVA",
					"description": {
						"pt-BR": "Ong de atendimento à jovens mães e seus filhos em situação de vulnerabilidade",
						"en-US": "NGO that cares for young mothers and their children in vulnerable situations"
					}
				}
			]
		},
		{
			"clients": [
				{
					"logo": "./src/assets/images/logos/luar.png",
					"alt": "Logo Luar",
					"client": "LUAR",
					"description": {
						"pt-BR": "Ong de atendimento à crianças, jovens e famílias em situação de risco social",
						"en-US": "NGO that cares to children, youth and families at social risk"
					}
				},
				{
					"logo": "./src/assets/images/logos/magic-beans.png",
					"alt": "Logo Magic Beans",
					"client": "MAGIC BEANS",
					"description": {
						"pt-BR": "Ong de atendimento e ajuda humanitária para a população do Haiti",
						"en-US": "NGO that attend and help people from Haiti"
					}
				},
				{
					"logo": "./src/assets/images/logos/momunes.png",
					"alt": "Logo Momunes",
					"client": "MOMUNES",
					"description": {
						"pt-BR": "Ong de promoção da cultura afro-brasileira",
						"en-US": "NGO who promote afro-brazilian culture"
					}
				},
				{
					"logo": "./src/assets/images/logos/monteiro-lobato.png",
					"alt": "Logo Monteiro Lobato",
					"client": "LAR ESCOLA MONTEIRO LOBATO",
					"description": {
						"pt-BR": "Ong de atendimento sócio assistencial à crianças e adolescentes",
						"en-US": "NGO care assistance partner to children and teenagers"
					}
				},
				{
					"logo": "./src/assets/images/logos/morais.png",
					"alt": "Logo Morais Produtos Naturais",
					"client": "MORAIS PRODUTOS NATURAIS",
					"description": {
						"pt-BR": "Empresa de comércio de produtos naturais",
						"en-US": "Company that work with natural products"
					}
				},
				{
					"logo": "./src/assets/images/logos/morumbi.png",
					"alt": "Logo Distribuidora Morumbi",
					"client": "DISTRIBUIDORA MORUMBI",
					"description": {
						"pt-BR": "Distribuidora",
						"en-US": "Distributor base in Sorocaba/SP - Brazil"
					}
				},
				{
					"logo": "./src/assets/images/logos/onzegraf.png",
					"alt": "Logo Onzegraf",
					"client": "ONZEGRAF",
					"description": {
						"pt-BR": "Empresa gráfica de Sorocaba",
						"en-US": "Printing company"
					}
				},
				{
					"logo": "./src/assets/images/logos/outlabel.png",
					"alt": "Logo Outlabel",
					"client": "OUTLABEL",
					"description": {
						"pt-BR": "Empresa de rótulos e etiquetas",
						"en-US": "Label company"
					}
				},
				{
					"logo": "./src/assets/images/logos/paroquia-sao-paulo-apostolo.png",
					"alt": "Logo Paróquia São Paulo Apóstolo",
					"client": "PARÓQUIA SÃO PAULO APÓSTOLO",
					"description": {
						"pt-BR": "Igreja Católica de Sorocaba",
						"en-US": "Catholic church in Sorocaba"
					}
				},
				{
					"logo": "./src/assets/images/logos/personal-college.png",
					"alt": "Logo Pesonal College",
					"client": "PERSONAL COLLEGE",
					"description": {
						"pt-BR": "Plataforma de conhecimento na área da Educação Física",
						"en-US": "Knowledge platform on Physical Education segment"
					}
				},
				{
					"logo": "./src/assets/images/logos/pintura-solidaria.png",
					"alt": "Logo Pintura Solidária",
					"client": "PINTURA SOLIDÁRIA",
					"description": {
						"pt-BR": "Ong de promoção cultural por meio de pintura à outras Entidades",
						"en-US": "NGO who promote culture through painting to other NGOs"
					}
				},
				{
					"logo": "./src/assets/images/logos/proex.png",
					"alt": "Logo PróEx",
					"client": "PROEX",
					"description": {
						"pt-BR": "Ong de atendimento à pessoa com deficiência",
						"en-US": "NGO to attend people with disability."
					}
				}
			]
		},
		{
			"clients": [
				{
					"logo": "./src/assets/images/logos/seda.png",
					"alt": "Logo Seda College",
					"client": "SEDA COLLEGE",
					"description": {
						"pt-BR": "Uma das maiores escolas de idiomas da Irlanda",
						"en-US": "One of the biggest Language School in Ireland"
					}
				},
				{
					"logo": "./src/assets/images/logos/tag.png",
					"alt": "Logo Contrutora TAG",
					"client": "CONSTRUTORA TAG",
					"description": {
						"pt-BR": "Empresa na área de construção civil",
						"en-US": "Civil Construction company"
					}
				},
				{
					"logo": "./src/assets/images/logos/teacher-laura.png",
					"alt": "Logo Teacher Laura",
					"client": "TEACHER LAURA",
					"description": {
						"pt-BR": "Escola de idiomas de Sorocaba",
						"en-US": "Language school in Sorocaba"
					}
				},
				{
					"logo": "./src/assets/images/logos/uirapuru.png",
					"alt": "Logo Colégio Uirapuru",
					"client": "COLÉGIO UIRAPURU",
					"description": {
						"pt-BR": "Um dos principais colégios de Sorocaba",
						"en-US": "Highly regarded high school in Sorocaba"
					}
				},
				{
					"logo": "./src/assets/images/logos/valentina.png",
					"alt": "Logo Valentina Peroni Arquitetura",
					"client": "VALENTINA PERONI",
					"description": {
						"pt-BR": "Arquitetura e Urbanismo",
						"en-US": "Architecture and Urbanism"
					}
				},
				{
					"logo": "./src/assets/images/logos/seven-cats.png",
					"alt": "Logo Seven Cats",
					"client": "Seven Cats",
					"description": {
						"pt-BR": "Parceiros na produção de vídeos institucionais",
						"en-US": "Partners in corporate video production"
					}
				},
				{
					"logo": "./src/assets/images/logos/wlasan.png",
					"alt": "Logo Faculdade Wlasan",
					"client": "FACULDADE WLASAN",
					"description": {
						"pt-BR": "Faculdade de graduação e pós graduação",
						"en-US": "University and Community College"
					}
				},
				{
					"logo": "./src/assets/images/logos/zarif.png",
					"alt": "Logo Zarif Seguros",
					"client": "ZARIF SEGUROS",
					"description": {
						"pt-BR": "Empresa do ramos de seguros",
						"en-US": "Insurance Broker"
					}
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/clients.json
// module id = 63
// module chunks = 0